"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = require("react");

var Utilities_1 = require("../../Utilities");

var Link_1 = require("../../Link");

var GroupSpacer_1 = require("./GroupSpacer");

var getClassNames = Utilities_1.classNamesFunction();

var GroupShowAllBase =
/** @class */
function (_super) {
  tslib_1.__extends(GroupShowAllBase, _super);

  function GroupShowAllBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._onSummarizeClick = function (ev) {
      _this.props.onToggleSummarize(_this.props.group);

      ev.stopPropagation();
      ev.preventDefault();
    };

    return _this;
  }

  GroupShowAllBase.prototype.render = function () {
    var _a = this.props,
        group = _a.group,
        groupLevel = _a.groupLevel,
        showAllLinkText = _a.showAllLinkText,
        styles = _a.styles,
        theme = _a.theme;
    var classNames = getClassNames(styles, {
      theme: theme
    });

    if (group) {
      return React.createElement("div", {
        className: classNames.root
      }, React.createElement(GroupSpacer_1.GroupSpacer, {
        count: groupLevel
      }), React.createElement(Link_1.Link, {
        onClick: this._onSummarizeClick
      }, showAllLinkText));
    }

    return null;
  };

  GroupShowAllBase.defaultProps = {
    showAllLinkText: 'Show All'
  };
  return GroupShowAllBase;
}(Utilities_1.BaseComponent);

exports.GroupShowAllBase = GroupShowAllBase;